module.exports = {
  lessons: 'Lessons',
  continue: 'Continue',
  details: 'Details',
  finish_course: 'Complete course',
  go_to_first_new: 'Go to first new content',
  x_of_y_lessons_done: '%{x} of %{y} lessons',
  go_to_course: 'Open course',
  search_course: 'Find a course',
  start_course: 'Start course',
  currently_no_courses_visible: 'There are currently no courses here.',
  courses_todo: 'Courses pending',
  sortLabels: {
    recent: 'Recent',
    name_asc: 'Alphabetically (A-Z)',
    name_desc: 'Alphabetically (Z-A)',
    available_from_desc: 'Date (newest first)',
    available_from_asc: 'Date (oldest first)',
  },
  sortShortLabels: {
    name_asc: 'A-Z',
    name_desc: 'Z-A',
    available_from_desc: 'Newest',
    available_from_asc: 'Oldest',
  },
  filters: {
    active: 'Active',
    finished: 'Completed',
    preview: 'Preview',
    mandatory: 'Mandatory',
    all: 'All',
    started: 'Started',
    expired: 'Expired',
  },
  show_all: 'Show all',
  show_less: 'Show less',
  participate: 'Start course',
  could_not_participate: 'Unfortunately, participation in the course failed. Please try again later.',
  previous_lesson: 'Previous lesson',
  new_contents_are_unfinished: 'New lessons have been added to this course. Please complete the new lessons to complete the course.',
  next_lesson: 'Next lesson',
  next_new_lesson: 'Next new lesson',
  next_chapter: 'Complete chapter',
  congratulations: 'Chapter complete!',
  congratulationsCertificate: 'Congratulations!',
  all_chapter_contents_done: 'You have completed all lessons in the "%{title}" chapter.',
  continue_with_chapter: 'Continue with Chapter “%{title}”',
  congratulations_course_done: 'Congratulations!',
  course_done: 'You have passed the course “%{title}” successfully!',
  received_certificate: 'You have acquired a new certificate!',
  content_started: 'Started',
  content_failed: 'Failed',
  content_passed: 'Passed',
  content_unfinished: 'Unfinished',
  earned_certificate: 'Certificate acquired',
  didnt_earn_certificate_yet: 'Not yet acquired',
  received_certificate_x: 'Certificate “%{x}” acquired',
  download_certificate_now: 'Download certificate now',
  has_certificate: 'With certificate',
  back_to_course_overview: 'Back to course overview',
  look_at_question: 'See question once again',
  look_at_questions: 'See questions once again',
  answer_questions_now: 'Answer questions',
  preview_btn: 'Preview',
  preview_label: 'Preview',
  preview_info: 'Course attendance is currently not possible. If you are interested, click this link to request access permission from your %{appname} team.',
  request_access: 'Request access',
  access_request_succeeded: 'We have received your request and will process it as soon as possible.',
  access_request_failed: 'Your request was unfortunately not successful.',
  admin_preview: {
    close: 'Close Preview',
    reason: {
      archived: 'The course “%{course}“ has been archived.',
      invisible: "The course “%{course}“ isn't visible.",
      not_available_anymore: 'The course “%{course}“ has expired.',
      not_yet_available: 'The course “%{course}“ is not yet available.',
      template: 'This is the template “%{course}“.',
    },
  },
  mandatory_course: 'Mandatory',
  tasks: 'Tasks',
  learning_duration: 'Duration',
  no_chapters: 'This course currently has no visible content.',
  no_chapters_email_contact: 'Please contact: %{email}',
  show_results: 'Show results',
  answered_x_of_y_questions_correctly: 'You have answered {correct} of one question correctly.|You have answered {correct} of {total} questions correctly.',
  answered_all_preview_questions: 'You answered all questions in the preview.',
  preview_doesnt_persist_results: 'The preview doesn\'t persist results.',
  endOfPreview: 'This is the end of the course preview. Results are not recorded in the preview, so you can restart the preview at any time.',
  restartPreview: 'Restart preview',
  courseContentInvisible: 'This content is not yet published and is not visible to users.',
  backToOverview: 'Back to overview',
  lessonsXofY: '{passed} / {total} Lessons',
  lessonsPassed: 'passed',
  noRelatedData: {
    appointment: 'There is no assigned appointment for this content.',
    certificate: 'There is no assigned certificate for this content.',
    form: 'There is no assigned form for this content.',
    questions: 'There are no questions assigned to this content.',
    learningMaterial: 'There is no assigned learning material for this content.',
    todoList: 'There are no tasks assigned to this content.',
  },
  navigationTutorialMobile: 'Swipe right or left to navigate through the lessons.',
  navigationTutorialDesktop: 'Click on the forward and back icons to navigate through the lessons.',
  menuTutorialMobile: 'Click on the chapter name at the top left to open the menu.',
  menuTutorialDesktop: 'You can open the menu at the top right.',
  reset_participation_progress: 'Reset course progress',
  reset_participation_progress_confirm: 'Are you sure you want to permanently reset your progress for this course?',
  confirm_reset_participation_progress: 'Yes, delete all of my progress',
  reset_course_progress_successful: 'Your progress has been reset successfully! You can now participate again.',
  reset_course_progress_failed: 'Reset your course progress was failed!',
  appUpdateRequired: 'App update required',
  updateAppRequired: 'To take this course, you need to update your app.',
  checkForUpdates: 'Check for updates',
  reloadPageToGetUpdates: 'Please reload the page to get the latest update.',
  appUpdatedButNotShowingContent: 'If your app is already up to date, please contact your <a href="mailto:{contactMail}">administrator.</a>',

  almostDone: {
    title: 'Almost done!',
    needToFinishContentsFirst: 'Before you have passed the course, you need to complete a few more contents.',
    followingContentsUnfinished: 'The following contents are still pending:',
    goToFirstUnfinishedContent: 'Go to first unfinished content',
    moreUnfinishedContent: 'And 1 more content ...|And {count} more contents ...',
  },
  contentsList: {
    lessons: 'Lessons',
    courseEnd: 'End of course',
    content_unfinished: 'Pending',
  },
  certificates: {
    unfinishedCertificateTitle: 'Certificate',
    unfinishedCertificateDescription: 'To acquire this certificate, you must first complete the previous course content.',
    certificateVersion1NotAvailableInPreview: 'Version 1 of the certificate is not available in Preview mode. Please upgrade to version 2.',
  },
  course_manager: 'Course manager',
  loadingQuestions: 'Loading questions...',
  clozeQuestionResetNotification: 'Your answer to this question was reset because the question was updated by an administrator.',
  content: {
    hotspots: {
      title: 'Hotspots',
      selectMarker: 'Select a marker to show more details.',
    },
  },
}
